import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { setNewPriceRTK } from "../utils/redux/slices/checkoutSlice";

const useCouponHook = () => {
  const couponValidate = useSelector((state) => state?.checkout?.coupon);
  const newPriceRTK = useSelector((state) => state?.checkout?.newPrice);
  const dispatch = useDispatch();
  const [coupon, setCoupon] = useState("");
  const [correctCoupon, setCorrectCoupon] = useState(false);
  const [price, setPrice] = useState(0);
  const [newPrice, setNewPrice] = useState(null);

  useEffect(() => {
    if (couponValidate && couponValidate.error) {
      console.log("error", couponValidate.error.message);
    }

    if (
      couponValidate &&
      couponValidate.data &&
      newPriceRTK === null 
    ) {
      console.log("couponValidate", couponValidate.data);
      if (couponValidate.data.success === true)
        if (couponValidate?.data?.discount_type === "price") {
          const discountPrice = couponValidate.data.discountPrice || 0;
          const newPrice = Math.max(price - discountPrice, 0);
          setNewPrice(newPrice);
          dispatch(setNewPriceRTK(newPrice));
          setCorrectCoupon(true);
        }

      if (couponValidate?.data?.discount_type === "percentage") {
        const discountPercentage = couponValidate.data.discountPercentage || 0;
        const discountAmount = (price * discountPercentage) / 100;
        const newPrice = Math.max(price - discountAmount, 0);
        setNewPrice(newPrice);
        dispatch(setNewPriceRTK(newPrice));
        setCorrectCoupon(true);
      }


      if (couponValidate?.data?.discount) {
        const newDiscount = couponValidate?.data?.discount || 0;
        const newPrice = Math.max(price - newDiscount, 0);
        setNewPrice(newPrice);
        dispatch(setNewPriceRTK(newPrice));
        setCorrectCoupon(true);
      }


    }
  }, [couponValidate]);

  return {
    coupon,
    setCoupon,
    correctCoupon,
    setCorrectCoupon,
    price,
    setPrice,
    newPrice,
  };
};

export default useCouponHook;
